import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import { useController } from "react-hook-form"
import { t } from "i18next"

function DropdownRHF(props) {
  const {
    name,
    control,
    options = [],
    placeholder = t("select"),
    btnClass,
    ...otherProps
  } = props

  const [dropdownOpen, setDropdownOpen] = useState(false)
  const { field, fieldState } = useController({ control, name })
  const { value, onChange } = field
  const checkState = fieldState.invalid ? "btn-soft-danger" : ""
  const renderValue = options.find(option => option.value === value)

  return (
    <Dropdown
      isOpen={dropdownOpen}
      toggle={() => setDropdownOpen(!dropdownOpen)}
      {...otherProps}
    >
      <DropdownToggle
        className={`btn btn-soft-primary ${checkState} ${btnClass}`}
        caret
      >
        {renderValue ? renderValue.label : placeholder}
        <i className="mdi mdi-chevron-down" />
      </DropdownToggle>
      <DropdownMenu>
        {options.length === 0 ? (
          <DropdownItem disabled>{t("empty")}</DropdownItem>
        ) : null}
        {options.map(option => {
          return (
            <DropdownItem
              key={option.value}
              active={value === option.value}
              onClick={() => onChange(option.value)}
            >
              {option.label}
            </DropdownItem>
          )
        })}
      </DropdownMenu>
    </Dropdown>
  )
}

DropdownRHF.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  btnClass: PropTypes.string,
}

export default DropdownRHF
